import { CompaniesInvoiceElementsService } from '@festina/moneyin-general-types/moneyin/services/CompaniesInvoiceElementsService'
import { useFestinaMutation } from '@festina-life/authentication'

const method =
  CompaniesInvoiceElementsService.companyInvoiceElementsServicePostCreateInvoice

export const useSubmitCreateInvoiceElementsInvoice = (
  tenantId: string,
  companyId: string,
) =>
  useFestinaMutation({
    component: 'moneyIn',
    isScenario: false,
    mutateFunction: async (_: Record<string, unknown>) => {
      await method({
        xTenantId: tenantId,
        companyId,
      })
    },
    roles:
      CompaniesInvoiceElementsService.companyInvoiceElementsServicePostCreateInvoice_roles,
  })
